import React from 'react';
import { useGallery } from '../../context/GalleryContext';
import { useUI } from '../../context/UIContext';
import { Brand } from '../brand/Brand';
import { MenuIcon } from '../icons';
import { SHOW_BRAND_SIGNATURE } from '../../constants';

// Persistent top bar: brand (home affordance → default gallery section) and, on mobile,
// the hamburger that opens the nav drawer. With the signature off the brand collapses to the
// wordmark, so the bar gets a bit more vertical padding to keep some breathing room.
export const Header = () => {
    const { defaultRoute } = useGallery();
    const { drawerOpen, toggleDrawer } = useUI();

    return (
        <header
            className={`flex items-center justify-between border-b border-tone-150 px-8 ${
                SHOW_BRAND_SIGNATURE ? 'py-5' : 'py-8'
            }`}
        >
            <Brand to={`/${defaultRoute}`} />
            <button
                type="button"
                onClick={toggleDrawer}
                aria-label="Open sections menu"
                aria-expanded={drawerOpen}
                aria-controls="mobile-nav-drawer"
                className="text-ink lg:hidden"
            >
                <MenuIcon size={24} />
            </button>
        </header>
    );
};
